// extracted by mini-css-extract-plugin
export var pillTrigger = "_59-0";